var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3314 4.90221C11.9438 6.21752 12.75 6.87518 12.75 8C12.75 9.12482 11.9438 9.78248 10.3314 11.0978C9.88631 11.4609 9.44484 11.8028 9.03917 12.0876C8.68327 12.3375 8.2802 12.5961 7.8629 12.8498C6.2543 13.828 5.44999 14.3171 4.72862 13.7756C4.00725 13.2341 3.94169 12.1005 3.81057 9.83323C3.77349 9.19205 3.75 8.56349 3.75 8C3.75 7.43651 3.77349 6.80795 3.81057 6.16677C3.94169 3.89953 4.00725 2.76591 4.72862 2.2244C5.44999 1.68288 6.2543 2.17198 7.8629 3.15019C8.2802 3.40395 8.68327 3.66246 9.03917 3.91238C9.44484 4.19725 9.88631 4.53911 10.3314 4.90221Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFilled);
export default __webpack_public_path__ + "static/media/playFilled.619b824e6308ee0c0e85c0bab986b3e8.svg";
export { ForwardRef as ReactComponent };